import { Action } from '@ngrx/store';
import {
  BaseOneResponseInterface,
  BulkResponseDataInterface,
  GetManyResponseInterface,
} from '../../../../shared/model/interface/crud-response-interface.model';
import { IApiAutomationQueryParams } from '../shared/api-automation.model';
import { IApiAutomationOption } from '../shared/api-automation.model';
import {
  IStationCombination,
  IStationCombinationRow,
} from '../../../../view/settings/api-automation-settings/station-combinations/station-combinations.model';

export enum ActionTypes {
  STATION_COMBINATIONS_DATA_LOADING = '[STATION_COMBINATIONS] STATION_COMBINATIONS DATA LOADING',
  STATION_COMBINATIONS_DATA_LOADED = '[STATION_COMBINATIONS] STATION_COMBINATIONS DATA LOADED',
  GET_STATION_COMBINATION = '[STATION_COMBINATIONS] GET_STATION_COMBINATION LOADING',
  GET_STATION_COMBINATION_COMPLETED = '[STATION_COMBINATIONS] GET_STATION_COMBINATION COMPLETED',
  ADD_STATION_COMBINATION = '[STATION_COMBINATIONS] ADD_STATION_COMBINATION',
  ADD_STATION_COMBINATION_COMPLETED = '[STATION_COMBINATIONS] ADD_STATION_COMBINATION COMPLETED',
  EDIT_STATION_COMBINATION = '[STATION_COMBINATIONS] EDIT_STATION_COMBINATION',
  EDIT_STATION_COMBINATION_COMPLETED = '[STATION_COMBINATIONS] EDIT_STATION_COMBINATION COMPLETED',
  DELETE_STATION_COMBINATIONS = '[STATION_COMBINATIONS] DELETE_STATION_COMBINATIONS',
  DELETE_STATION_COMBINATIONS_COMPLETED = '[STATION_COMBINATIONS] DELETE_STATION_COMBINATIONS COMPLETED',
  CHANGE_ACTIVITIES_DATA_LOADING = '[STATION_COMBINATIONS] CHANGE_ACTIVITIES DATA LOADING',
  CHANGE_ACTIVITIES_DATA_COMPLETED = '[STATION_COMBINATIONS] CHANGE_ACTIVITIES DATA COMPLETED',
  HEARTBEAT_SETTINGS_DATA_LOADING = '[STATION_COMBINATIONS] HEARTBEAT_SETTINGS DATA LOADING',
  HEARTBEAT_SETTINGS_DATA_COMPLETED = '[STATION_COMBINATIONS] HEARTBEAT_SETTINGS DATA COMPLETED',
  FETCH_ERROR = '[STATION_COMBINATIONS] FETCH ERROR',
}

export class StationCombinationsLoading implements Action {
  readonly type = ActionTypes.STATION_COMBINATIONS_DATA_LOADING;

  constructor(public params: IApiAutomationQueryParams) {}
}

export class StationCombinationsLoaded implements Action {
  readonly type = ActionTypes.STATION_COMBINATIONS_DATA_LOADED;

  constructor(public payload: GetManyResponseInterface<IStationCombination>) {}
}

export class GetStationCombination implements Action {
  readonly type = ActionTypes.GET_STATION_COMBINATION;

  constructor(public recordId: number) {}
}

export class GetStationCombinationCompleted implements Action {
  readonly type = ActionTypes.GET_STATION_COMBINATION_COMPLETED;

  constructor(public payload: BaseOneResponseInterface<IStationCombination>) {}
}
export class AddStationCombination implements Action {
  readonly type = ActionTypes.ADD_STATION_COMBINATION;

  constructor(
    public record: IStationCombinationRow,
    public hideLoaderAfterSuccess: boolean = true,
  ) {}
}

export class AddStationCombinationCompleted implements Action {
  readonly type = ActionTypes.ADD_STATION_COMBINATION_COMPLETED;

  constructor(public payload: BaseOneResponseInterface<IStationCombination>) {}
}
export class EditStationCombination implements Action {
  readonly type = ActionTypes.EDIT_STATION_COMBINATION;

  constructor(
    public recordId: number,
    public record: IStationCombinationRow,
    public hideLoaderAfterSuccess: boolean = true,
  ) {}
}

export class EditStationCombinationCompleted implements Action {
  readonly type = ActionTypes.EDIT_STATION_COMBINATION_COMPLETED;

  constructor(public payload: BaseOneResponseInterface<IStationCombination>) {}
}
export class DeleteStationCombinations implements Action {
  readonly type = ActionTypes.DELETE_STATION_COMBINATIONS;

  constructor(public payload: number[]) {}
}

export class DeleteStationCombinationsCompleted implements Action {
  readonly type = ActionTypes.DELETE_STATION_COMBINATIONS_COMPLETED;

  constructor(
    public isBulk: boolean,
    public response: BulkResponseDataInterface,
  ) {}
}
export class ChangeActivitiesDataLoading implements Action {
  readonly type = ActionTypes.CHANGE_ACTIVITIES_DATA_LOADING;
}

export class ChangeActivitiesDataCompleted implements Action {
  readonly type = ActionTypes.CHANGE_ACTIVITIES_DATA_COMPLETED;

  constructor(public payload: IApiAutomationOption[]) {}
}
export class HeartbeatSettingsDataLoading implements Action {
  readonly type = ActionTypes.HEARTBEAT_SETTINGS_DATA_LOADING;
}

export class HeartbeatSettingsDataCompleted implements Action {
  readonly type = ActionTypes.HEARTBEAT_SETTINGS_DATA_COMPLETED;

  constructor(public payload: IApiAutomationOption[]) {}
}
export class FetchError implements Action {
  readonly type = ActionTypes.FETCH_ERROR;

  constructor(public errorAction: ActionTypes) {}
}

export type StationCombinationActions =
  | StationCombinationsLoading
  | StationCombinationsLoaded
  | GetStationCombination
  | GetStationCombinationCompleted
  | AddStationCombination
  | AddStationCombinationCompleted
  | EditStationCombination
  | EditStationCombinationCompleted
  | DeleteStationCombinations
  | DeleteStationCombinationsCompleted
  | ChangeActivitiesDataLoading
  | ChangeActivitiesDataCompleted
  | HeartbeatSettingsDataLoading
  | HeartbeatSettingsDataCompleted
  | FetchError;
